import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  return (
    <main>
      <Breadcrumb items={[{ label: '关于我们' }]} />

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            关于草民影院
          </h1>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto leading-relaxed">
            草民影院成立于2020年，是一家专注于提供高清在线影视服务的平台。我们致力于为广大影迷打造最佳的在线观影体验，让每个人都能轻松享受蓝光画质的电影和电视剧。
          </p>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
            品牌理念
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                icon: 'ri-movie-2-line',
                title: '高清画质',
                desc: '蓝光1080P是基本标准，部分热门影片更支持4K超清画质。我们相信好的内容值得用最好的画质呈现。',
              },
              {
                icon: 'ri-speed-up-line',
                title: '流畅不缓冲',
                desc: '先进的CDN加速技术和自适应码率技术，确保任何网络环境下都能流畅播放，真正做到即点即看。',
              },
              {
                icon: 'ri-global-line',
                title: '海量资源',
                desc: '每日更新的海量影视资源，涵盖电影、电视剧、动漫、纪录片等多种类型，满足不同观众的观影需求。',
              },
            ].map((item) => (
              <div
                key={item.title}
                className="p-6 rounded-xl bg-background-50 border border-background-200 text-center"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-primary-100 text-primary-500">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-800 text-lg mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
            用户口碑
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              {
                name: '张先生',
                role: '资深影迷',
                content: '草民影院的画质真的没话说！1080P蓝光看大片太爽了，而且完全不卡顿。以前在其他平台经常缓冲，现在只用草民影院！',
                rating: 5,
              },
              {
                name: '李女士',
                role: '追剧达人',
                content: '每天下班后最大的乐趣就是在草民影院追剧。更新快、画质好，最重要的是不卡！追了三年的剧，真的离不开这个平台了。',
                rating: 5,
              },
              {
                name: '王同学',
                role: '大学生',
                content: '宿舍网速一般般，但草民影院居然不卡！自适应码率技术真的厉害。而且不用下载任何播放器，即点即看太方便了。',
                rating: 5,
              },
              {
                name: '刘先生',
                role: '家庭用户',
                content: '周末一家人最喜欢用草民影院看电影。资源丰富，什么类型的片子都有，老人小孩都能找到喜欢的。画质清晰，大屏幕上看效果超棒！',
                rating: 5,
              },
              {
                name: '陈女士',
                role: '文艺青年',
                content: '除了热门大片，草民影院的纪录片和独立电影资源也很丰富。作为一个文艺片爱好者，这里真的是宝藏平台！',
                rating: 5,
              },
              {
                name: '赵先生',
                role: '科技爱好者',
                content: '从技术层面来说，草民影院的流媒体传输做得非常出色。即点即看零延迟，这个体验已经超过了很多国际流媒体平台。',
                rating: 5,
              },
            ].map((review, index) => (
              <div
                key={index}
                className="p-5 rounded-xl bg-background-100 border border-background-200"
              >
                <div className="flex gap-1 mb-3">
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-sm"></i>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "{review.content}"
                </p>
                <div>
                  <p className="font-heading font-bold text-foreground-800 text-sm">
                    {review.name}
                  </p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
            联系我们
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-6 rounded-xl bg-background-50 border border-background-200 flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-foreground-800 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-500">contact@uwkltw.cn</p>
                <p className="text-xs text-foreground-400 mt-1">工作日24小时内回复</p>
              </div>
            </div>
            <div className="p-6 rounded-xl bg-background-50 border border-background-200 flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                <i className="ri-customer-service-2-line text-xl"></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-foreground-800 mb-1">在线客服</h3>
                <p className="text-sm text-foreground-500">工作日 9:00 - 18:00</p>
                <p className="text-xs text-foreground-400 mt-1">节假日休息</p>
              </div>
            </div>
            <div className="p-6 rounded-xl bg-background-50 border border-background-200 flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-foreground-800 mb-1">微信公众号</h3>
                <p className="text-sm text-foreground-500">搜索"草民影院"</p>
                <p className="text-xs text-foreground-400 mt-1">获取最新影视资讯</p>
              </div>
            </div>
            <div className="p-6 rounded-xl bg-background-50 border border-background-200 flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                <i className="ri-weibo-line text-xl"></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-foreground-800 mb-1">官方微博</h3>
                <p className="text-sm text-foreground-500">@草民影院官方微博</p>
                <p className="text-xs text-foreground-400 mt-1">每日影视推荐更新</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '草民影院',
            url: 'https://uwkltw.cn/',
            description: '草民影院提供高清电影、超清电视剧，蓝光画质1080P在线观看，高清不卡，流畅不缓冲，即点即看。',
            email: 'contact@uwkltw.cn',
            foundingDate: '2020',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              email: 'contact@uwkltw.cn',
              availableLanguage: 'Chinese',
            },
            sameAs: [
              'https://weibo.com/caominyingyuan',
              'https://weixin.qq.com/',
            ],
          }),
        }}
      />
    </main>
  );
}